import { get, post, put } from 'utils/methods';

export function getSegmentsApi(data, headers) {
    return get(`${process.env.REACT_APP_REST}segment`, data, headers);
}

export function getEditableSegmentsApi(data, headers) {
    return get(`${process.env.REACT_APP_REST}segment/${data}`, headers);
}

export function updateSegmentTranslateApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/segment/translate`, data, headers);
}

export function addNewSegmentApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/segment`, data, headers);
}

export function editSegmentApi(data, headers) {
    return put(`${process.env.REACT_APP_REST}commands/segment`, data, headers);
}

export function enableDisableStatusSegmentApi(data, headers) {
    return put(`${process.env.REACT_APP_REST}commands/segment/status`, data, headers);
}
